module.exports = __webpack_public_path__ + "media/Great_Bittern.50771529.mp3";